import {
  CompetitionLevel,
  CompetitionType,
  CompositionType,
} from "../enums/domain.enum.js";

// ─── Competition Type ────────────────────────────────────────

export const COMPETITION_TYPE_LABELS: Record<CompetitionType, string> = {
  [CompetitionType.SINGLE]: "Tête-à-tête",
  [CompetitionType.DOUBLE]: "Doublette",
  [CompetitionType.TRIPLE]: "Triplette",
};

/** Uppercase variant used on public-facing pages. */
export const COMPETITION_TYPE_LABELS_UPPER: Record<CompetitionType, string> = {
  [CompetitionType.SINGLE]: "TÊTE-À-TÊTE",
  [CompetitionType.DOUBLE]: "DOUBLETTE",
  [CompetitionType.TRIPLE]: "TRIPLETTE",
};

// ─── Competition Level ───────────────────────────────────────

export const COMPETITION_LEVEL_LABELS: Record<CompetitionLevel, string> = {
  [CompetitionLevel.LOCAL]: "Local",
  [CompetitionLevel.DEPARTMENTAL]: "Départemental",
  [CompetitionLevel.REGIONAL]: "Régional",
  [CompetitionLevel.NATIONAL]: "National",
  [CompetitionLevel.CHAMPIONSHIP]: "Championnat",
  [CompetitionLevel.PROMOTION]: "Promotion",
  [CompetitionLevel.MASTER]: "Master",
  [CompetitionLevel.PRESTIGE]: "Prestige",
};

// ─── Composition Type ────────────────────────────────────────

export const COMPOSITION_TYPE_LABELS: Record<CompositionType, string> = {
  [CompositionType.MELEE]: "Mélée",
  [CompositionType.FORMEE]: "Formée",
  [CompositionType.FORMEE_ALEATOIRE]: "Formée aléatoire",
};
